import { Controller } from "@hotwired/stimulus";

const interactiveElementSelector = [
  "a",
  "button",
  "form",
  "input",
  "select",
  "textarea",
  "label",
  "[data-clickable-row-ignore]",
].join(",");

export default class extends Controller {
  static targets = ["link"];

  open(event) {
    // Let nested controls and previously handled events keep their own behavior.
    if (
      event.defaultPrevented ||
      event.target.closest(interactiveElementSelector)
    ) {
      return;
    }

    // Preserve common new-tab gestures when clicking elsewhere in the row.
    if (event.metaKey || event.ctrlKey || event.button === 1) {
      event.preventDefault();
      window.open(this.linkTarget.href, "_blank", "noopener");
      return;
    }

    // Use the real link so Turbo handles ordinary navigation.
    if (event.type === "click") this.linkTarget.click();
  }
}
